import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const PasswordErrorMap = {
  INVALID_PASSWORD_FORMAT: { errorCode: 40015, errorType: ErrorType.BUSINESS_LOGIC },
  NEW_PASSWORD_SAME_AS_OLD: { errorCode: 40016, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_INSUFFICIENT_DIGIT: { errorCode: 40023, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_INSUFFICIENT_UPPERCASE: { errorCode: 40021, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_INSUFFICIENT_LOWERCASE: { errorCode: 40020, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_TOO_SHORT: { errorCode: 40018, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_TOO_LONG: { errorCode: 40019, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_ILLEGAL_REPEAT: { errorCode: 40024, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_ILLEGAL_QWERTY: { errorCode: 40026, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_ILLEGAL_NUMERIC: { errorCode: 40027, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_ILLEGAL_ALPHABETICAL: { errorCode: 40028, errorType: ErrorType.BUSINESS_LOGIC },
  PASSWORD_ILLEGAL_SEQUENCE: { errorCode: 40029, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getPasswordErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      PasswordErrorMap.INVALID_PASSWORD_FORMAT.errorCode,
      {
        errorCode: PasswordErrorMap.INVALID_PASSWORD_FORMAT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_INSUFFICIENT_UPPERCASE.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_INSUFFICIENT_UPPERCASE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_INSUFFICIENT_DIGIT.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_INSUFFICIENT_DIGIT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_INSUFFICIENT_LOWERCASE.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_INSUFFICIENT_LOWERCASE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.NEW_PASSWORD_SAME_AS_OLD.errorCode,
      {
        errorCode: PasswordErrorMap.NEW_PASSWORD_SAME_AS_OLD.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_TOO_SHORT.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_TOO_SHORT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
        openModal: false,
      },
    ],
    [
      PasswordErrorMap.PASSWORD_TOO_LONG.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_TOO_LONG.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],

    [
      PasswordErrorMap.PASSWORD_ILLEGAL_QWERTY.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_QWERTY.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_ILLEGAL_NUMERIC.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_NUMERIC.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_ILLEGAL_ALPHABETICAL.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_ALPHABETICAL.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_ILLEGAL_SEQUENCE.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_SEQUENCE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
    [
      PasswordErrorMap.PASSWORD_ILLEGAL_REPEAT.errorCode,
      {
        errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_REPEAT.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PASSWORD,
        callBack: () => {},
      },
    ],
  ]);
};
